const Footer = () => {
  return (
    <footer>
      <p className='attribution'>
        Challenge by{' '}
        <a
          href='https://www.frontendmentor.io?ref=challenge'
          rel='noreferrer'
          target='_blank'>
          Frontend Mentor
        </a>
        . Coded by{' '}
        <a href='https://www.claytondewey.com' rel='noreferrer' target='_blank'>
          Clayton Dewey
        </a>
        .
      </p>
    </footer>
  );
};
export default Footer;
